import { Signal } from "@/constants/signal/signal"
import type { ReviewWithSignals } from "@/types/models"

export enum ReviewTag {
  VERIFIED_CUSTOMER = "verified_customer",
  LONG_TERM_CUSTOMER = "long_term_customer",
  RECENT = "recent",
  UNFAIR = "unfair",
  COMPLAINT = "complaint",
}

export const dataByReviewTag: Record<
  ReviewTag,
  {
    title: string
    isWeighted: boolean
    doesReviewHaveTag: (review: ReviewWithSignals) => boolean
  }
> = {
  [ReviewTag.VERIFIED_CUSTOMER]: {
    title: "Verified Customer",
    isWeighted: true,
    doesReviewHaveTag: (review) =>
      review.signals?.[Signal.STATUS]?.label === "yes",
  },
  [ReviewTag.LONG_TERM_CUSTOMER]: {
    title: "Long-term Customer",
    isWeighted: true,
    doesReviewHaveTag: (review) =>
      review.signals?.[Signal.TENURE]?.label === "yes",
  },
  [ReviewTag.RECENT]: {
    title: "Recent",
    isWeighted: true,
    doesReviewHaveTag: (review) =>
      review.signals?.[Signal.RECENCY]?.label === "yes",
  },
  [ReviewTag.UNFAIR]: {
    title: "Unfair",
    isWeighted: false,
    doesReviewHaveTag: (review) =>
      review.signals?.[Signal.FAIRNESS]?.label === "no",
  },
  [ReviewTag.COMPLAINT]: {
    title: "Complaint",
    isWeighted: false,
    doesReviewHaveTag: (review) =>
      review.signals?.[Signal.DECEPTION]?.label === "yes",
  },
}
